<template>

    <div v-if="field" style="min-height: 500px;">
        <b-button block disabled >All Lead Tags</b-button>

        <b-table id="my-tags" small :items="filteredTags" :fields="tagVisibleFields" primary-key="dobjId"
                 :per-page="tagsPerPage" :current-page="tagsCurrentPage" @row-clicked="rowTagClicked"
                 :tbody-tr-class="tbodyRowClass"
                 :sort-by.sync="tagsSortBy" :sort-desc.sync="tagsSortDesc">

            <template #top-row="">
                <!-- Icon -->
                <td>
                    <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                        <template #button-content>
                            <template v-if="selectVal['style']">
                                <b-icon icon="filter" :style="selectVal['style'] ? 'color:'+selectVal['style'] : 'color: #000000;'"></b-icon>
                            </template>
                            <template v-else>
                                <b-icon icon="filter"></b-icon>
                            </template>
                        </template>
                        <b-dropdown-item @click="selectVal['style'] = undefined">
                            <b-icon icon="x-circle"></b-icon>
                        </b-dropdown-item>
                        <b-dropdown-divider></b-dropdown-divider>
                        <b-dropdown-item :value="option" v-for="option in tagOptions['style']" :key="option"
                                         @click="selectVal['style'] = option">
                            <b-icon icon="square-fill" :style="'color:'+option"></b-icon>
                        </b-dropdown-item>
                    </b-dropdown>
                </td>
                <!-- Label column -->
                <td>
                    <b-form-input id="tag-filter" v-model="selectVal['label']" type="search" placeholder="Type to Search"></b-form-input>
                </td>
                <!-- Type column -->
                <td>
                    <b-form-select class="form-control form-control-sm" @click.stop.prevent v-model="selectVal['type']">
                        <b-form-select-option :value="undefined"></b-form-select-option>
                        <b-form-select-option :value="option" v-for="option in tagOptions['type']" :key="option">{{ option }}</b-form-select-option>
                    </b-form-select>
                </td>
                <!-- Selected column -->
                <td></td>
            </template>

            <!-- Icon column -->
            <template v-slot:cell(icon)="row">
                <b-icon icon="square-fill" :style="'color:'+row.item.style"></b-icon>
            </template>

            <!-- Selected column -->
            <template v-slot:cell(selected)="{ item }" >
                <b-checkbox :checked="isTagSelected(item)" @change="rowTagClicked(item)"></b-checkbox>
            </template>
        </b-table>

        <b-pagination v-model="tagsCurrentPage" :total-rows="tagsRows" :per-page="tagsPerPage" align="fill"
                      aria-controls="my-tags"></b-pagination>

        <b-button block disabled class="mt-4">Selected Lead Tags</b-button>

        <b-card-body>
            <div class="d-inline-block" style="font-size: 1.5rem;">
                <b-form-tag v-for="tag in selectedTags"
                            @remove="removeTag(field, tag.value)"
                            :key="tag.value" :title="tag.label" class="mr-1" variant="primary">{{ tag.label }}</b-form-tag>
            </div>
        </b-card-body>
    </div>
</template>

<script>
import _ from "lodash";

export default {
    name: "PortalFieldTags",
    props: {
        currentPortal: Object,
        field: Object,
        items: Array,
    },
    data() {
        return {
            fields: [
                {key: 'icon', label: '', sortable: true, class: 'text-center align-middle col-icon', visible: true},
                {key: 'style', label: '', sortable: true, class: 'text-center align-middle col-icon', visible: false},
                {key: 'label', sortable: true, visible: true},
                {key: 'type', sortable: true, visible: true, class: 'col-type'},
                {key: 'selected', sortable: false, label: '', class: 'text-center align-middle col-icon', visible: true},
            ],
            tagsPerPage: 5,
            tagsCurrentPage: 1,
            tagsSortBy: 'label',
            tagsSortDesc: false,
            selectVal: {
                icon: undefined,
                style: undefined,
                label: undefined,
                type: undefined,
                selected: undefined
            }
        }
    },
    computed: {
        tagsRows() {
            return this.filteredTags.length
        },
        filteredTags() {
            return this.items.filter(item => {
                let keep = true;

                // This is a basic equality filter. What I did in the actual code was to have an object with filter functions for each key. If a key was missing, it defaulted to straight equality.
                this.tagFields.forEach(field => {
                    let key = field.key;
                    if (key === 'label') {
                        keep = keep && (this.selectVal[key] === undefined ||
                            String(item[key]).toLowerCase().trim().includes(this.selectVal[key].toLowerCase().trim()));
                    } else {
                        keep = keep && (this.selectVal[key] === undefined ||
                            item[key] === this.selectVal[key]);
                    }
                });

                return keep;
            });
        },
        tagFields() {
            return this.fields;
        },
        tagVisibleFields() {
            return this.tagFields.filter(field => field.visible)
        },
        tagOptions() {
            // This could be simplified if the select was it's own component.
            const options = {};
            this.tagFields.forEach(field => {
                if (field.key !== 'label') {
                    const vals = this.items.map(item => item[field.key]);

                    // Cheap and efficient unique.
                    options[field.key] = Array.from(new Set(vals));
                }
            });

            return options;
        },
        selectedTags() {
            return this.orderByPosition(Object.values(this.field.fieldValues));
        },
    },
    methods: {
        orderByPosition(list) {
            return _.orderBy(list, 'position')
        },
        isTagSelected(tag) {
            return tag.dobjId in this.field.fieldValues;
        },
        tbodyRowClass(item) {
            if(item && this.isTagSelected(item)){
                return ["b-table-row-selected", "table-primary", "cursor-pointer"]
            } else {
                return ["cursor-pointer"]
            }
        },
        changeTagPosition(field) {
            this.orderByPosition(Object.values(field.fieldValues)).forEach((tag, index) => {
                tag.position = index;
            });
        },
        addTag(field, tag) {
            if (!field.fieldValues) {
                field.fieldValues = {};
            }
            this.$set(field.fieldValues, tag.dobjId, {value: tag.dobjId, label: tag.label});
            this.changeTagPosition(field);
        },
        removeTag(field, tagId) {
            this.$delete(field.fieldValues, tagId);
            this.changeTagPosition(field);
        },
        rowTagClicked(tag) {
            if(tag && this.isTagSelected(tag)){
                this.removeTag(this.field, tag.dobjId);
            }else{
                this.addTag(this.field, tag);
            }
        },
    }
}
</script>

<style lang="scss">
    .cursor-pointer{
        cursor: pointer;
    }

    .col-type {
        width: 100px;
    }
</style>